import React from 'react';
import getDoc from "../../qdoc";
import "bootstrap";
import downloadCSV from "../../downloadCSV";
import NumberFormat from 'react-number-format';


export default class Tab_table extends React.Component {
  constructor(props) {
    super(props);

    this.getCube = getDoc.then(doc => {
      return doc.createSessionObject({
        qInfo: {
          qType: "visualization"
        },
        qHyperCubeDef: {
          qStateName: this.props.qStateName,          
          qDimensions: [
            {
              qDef: {
                qFieldDefs: ['Index'],
                qSortCriterias: [{ 
                  qSortByAscii: 1
                }]
              }, 
              qNullSuppression: false
            },
            {
            qDef: {
              qFieldDefs: ['Contributor Name'],
              qFieldLabels: ['Donor'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Political Party'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Political Entity'],
              qFieldLabels: ['Political Entity'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Recipient'],
              qFieldLabels: ['Recipient'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Source'],
              qFieldLabels: ['Region'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Contributor City/Province/Postal'],
              qFieldLabels: ['Donor Location'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Contributor Type'],
              qFieldLabels: ['Donor Type'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Electoral Event'],
              qFieldLabels: ['Electoral Event'],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Year'],
              qFieldLabels: ['Year'],
              qSortCriterias: [{ 
                qSortByAscii: -1
              }]
            }, 
            qNullSuppression: false
          }
        ],
          qMeasures: [
          // {
          //   qDef: {
          //     qDef: "num(Sum(DonationCount),'#,##0')",
          //     qLabel: 'Donations'
          //   },
          //   qSortBy: {
          //     qSortByNumeric: -1
          //   }
          // },
          {
            qDef: {
              qDef: "num(sum([Total Amount]),'$#,##0.00')",
              // qDef: "num(Sum([Non-Monetary Amount])+sum([Total Amount]),'$#,##0')",
              qLabel: 'Amount'
            },
            qSortBy: {
              qSortByNumeric: -1
            }
          }
        ],
          qInterColumnSortOrder: [10,1]
        }
      });
    });

    this.state = {
      labels: [],
      data: [],
      updating: false,
      sortColumn: 10,
      exporting: false,
      size: 0,
      offset: 0
    }
    this.exportData = this.exportData.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.getLayout();
    this.update();
    this.getCube.then(cube => {
      cube.on('changed', () => {
        this.update();
      });
    });
    // $(this.refs['export']).popover(); 
    $(this.refs['tooltip']).tooltip();   
  }

  update() {
    $(this.refs['scrollable']).scrollTop(0);
    this.setState({offset: 0, updating: true});
    this.getHyperCubeData();
    this.getLayout();
  }

  getLayout() {
    this.getCube.then(cube => {
      cube.getLayout().then(layout => {
        let labels = [];
        layout.qHyperCube.qDimensionInfo.forEach(row => { labels.push(row.qFallbackTitle); });
        layout.qHyperCube.qMeasureInfo.forEach(row => { labels.push(row.qFallbackTitle); });
        this.setState({ labels: labels, size: layout.qHyperCube.qSize.qcy });
      });
    });
  }

  getHyperCubeData() {
    this.getCube.then(cube => {
      cube.getHyperCubeData("/qHyperCubeDef", [{
        qTop: this.state.offset, 
        qLeft: 1, 
        qHeight: 10, 
        qWidth: 10
      }]).then(cubeData => {
        this.setState({data: cubeData[0].qMatrix, updating: false});
      });
    });
  }

  exportData() {
    this.setState({ exporting: true });
    this.getCube.then(cube => {
      cube.getHyperCubeData("/qHyperCubeDef", [{
        qTop: 0, 
        qLeft: 1, 
        qHeight: 1000, 
        qWidth: 10
      }]).then(cubeData => {
        cubeData = cubeData[0].qMatrix.map(row => {
          return {
            "Contributor Name": row[0].qText,
            "Political Party": row[1].qText,
            "Political Entity": row[2].qText,
            "Recipient": row[3].qText,
            "Region": row[4].qText,
            "Contributor Location": row[5].qText,
            "Type": row[6].qText,
            "Electoral Event": row[7].qText,
            "Date": row[8].qText,
            "Donation Amount": row[9].qText
          }
        });
        downloadCSV({data: cubeData});
        this.setState({ exporting: false });
      });
    });
  }

  changeSort(event, i) {
    this.getCube.then(cube => {
      cube.applyPatches([{
        qOp: "replace",
        qPath: "/qHyperCubeDef/qInterColumnSortOrder",
        qValue: JSON.stringify([i])
      }]).then(() => {
        this.setState({ sortColumn: i });
      });
    });
  }
  
  render() {
    return (
      <div className="relative mb-5">
        <div className="d-flex align-items-end" style={{borderBottom:'2px solid #ECEEEF'}}>
          <div className="">
            Donation <span className="textgreen">Details </span> <span className="small"> <NumberFormat value={this.state.size} displayType={'text'} thousandSeparator={true} prefix={'('} suffix={' rows)'} /> </span>
          </div>
          <div className="p-2 ml-auto">
            <div className="btn-group">
              <button type="button" className={`${this.state.exporting ? 'disabled' : null } btn btn-sm btn-secondary dropdown-toggle`} data-toggle="dropdown"> 
                <span style={{display: this.state.exporting ? 'none' : null}}>Data Export</span>
                <span style={{display: this.state.exporting ? null : 'none'}}><i className='fa fa-circle-o-notch fa-spin fa-fw'/> Exporting</span>
              </button>
              <div className="dropdown-menu dropdown-menu-right">
                <a className="dropdown-item" style={{fontSize:'13px'}} href="javascritp:void(0)" onClick={this.exportData}>Download Current View*</a>   
                <a className="dropdown-item" style={{fontSize:'13px'}} href="https://webapps.qlik.com/np-donations/Donations.zip">Download Complete Data Set</a>   
              </div>             
            </div>
          </div>
        </div>
        <div className={`spinner ${this.state.updating ? 'updating' : null}`}><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
        <div style={{height: '400px', overflow: 'auto', borderBottom: '2px solid #ECEDEF'}} className="overflow-scrolling" ref="scrollable" onScroll={this.handleScroll}>
          <div style={{height: '100%', overflowY: 'hidden'}} ref="table">
            <table className="table table-responsive table-sm" style={{overflow: 'visible'}}>
              <thead>
                <tr>
                  {this.state.labels.map((row,i) => {
                    return  i > 0 ? <th key={i} className={`${this.state.sortColumn === i ? 'active' : ''}`} onClick={event => {this.changeSort(event, i)}}>{row}</th> : null;
                  })}
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((row, i) => {
                  return <tr key={i}>
                    {row.map((item, i) => {
                      return <td key={i}>
                        {item.qText}
                      </td>;
                    })}
                  </tr>;
                })}
              </tbody>
            </table>
          </div>
          <div style={{height: `${Math.min(20 * (this.state.size - 2), 10000)}px`}} />
        </div>
        <div className="tablefooter mt-2 mb-5">*Downloading the current view will export up to 1000 rows. The complete data set is also available for download.</div>
      </div>
    );
  }
  handleScroll(event) {
    let itemScrollSize = 20 * (this.state.size - 2) < 10000 ? 20 : 10000 / (this.state.size - 2);
    $(this.refs['table']).css('transform', `translateY(${$(this.refs['scrollable']).scrollTop()}px)`);
    this.setState({offset: Math.floor($(this.refs['scrollable']).scrollTop() / itemScrollSize)});
    this.getHyperCubeData();
  }
}


// WEBPACK FOOTER //
// ./components/Table/index.js